var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inertia-link',{attrs:{"href":_vm.showUrl()}},[(_vm.text)?_c('span',_vm._g(_vm._b({attrs:{"id":"inner-span"},domProps:{"textContent":_vm._s(_vm.text)}},'span',_vm.$attrs,false),_vm.$listeners)):_vm._e(),_vm._t("text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }